import React from "react";

const About = () => {
  return (
    <section id="about" className="section-padding">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <img 
              src="https://images.unsplash.com/photo-1752650735496-7cf951aef58f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
              alt="Young professionals collaborating at desk with laptop"
              className="section-image"
              loading="lazy"
            />
          </div>
          <div className="about-content">
            <h2 className="section-heading">Your vision, our prodigy</h2>
            <p className="section-text about-paragraph">
              We're career architects, not typical recruiters. We understand what organizations need and align them with professionals who thrive from day one — while designing career pathways that maximize your earning potential and trajectory.
            </p>
            <p className="section-text about-paragraph">
              <strong>The difference?</strong> Exclusive partnerships across government, financial institutions, and enterprise organizations. All these sectors require cutting-edge technology skills and specialized expertise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
